import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'

export type DayforceJobsIssuesCompany = {
  id: number
  name: string
}

export type DayforceJobsIssuesItem = {
  agencyId: string
  startsAt: string
  jobId: string
  bookingId: string
  shiftId: number | null
  company: DayforceJobsIssuesCompany
  issues: string[]
}

export type DayforceJobsIssuesItems = DayforceJobsIssuesItem[]

type ListDayforceJobsIssuesRequest = {
  page: number
  pageSize: number
  agencyId?: string[] | null
}

export type ListDayforceJobsIssuesResponse = {
  items: DayforceJobsIssuesItems
  totalRows: number
  totalPages: number
  currentPage: number
  pageSize: number
}

export const listDayforceJobsIssues = async (
  request: ListDayforceJobsIssuesRequest
): Promise<ListDayforceJobsIssuesResponse> => {
  const params: Record<string, string | number | string[] | null | undefined> =
    {
      page: request.page,
      page_size: request.pageSize,
      agency_id: request.agencyId,
    }

  const response = await api.get<ListDayforceJobsIssuesResponse>(
    '/admin/dayforce/jobs_issues',
    { params, paramsSerializer: queryParamSerializer }
  )
  return response.data
}
